interface SectionHeadingProps {
  index: string;
  title: string;
  desc: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  index,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : ""}`}>
      <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-700">
        <span className="font-heading text-sm font-bold text-accent-500">{index}</span>
        <span className="h-px w-6 bg-primary-300"></span>
        {title}
      </span>
      <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      <p
        className={`max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-[15px] ${
          isCenter ? "mx-auto" : ""
        }`}
      >
        {desc}
      </p>
    </div>
  );
}